import * as types from './types';
const getters = {
  [types.BOOKING]: state => state.booking,
  [types.BOOKING_LIST]: state => state.bookingList,
};

export default getters;
